import PIXI from 'pixi.js/src';
import data from './../data/data';
import config from './../config/config';
import router from './../router/router';
import audioHelper from './../helpers/audio';
import renderHelper from './../helpers/render';
import frameAnimationHelper from './../helpers/frame-animation';
import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';

const gameOverView = {
  textLetterInt: 0,
  writeTextInterval: 0,
  graphicWidth: 400,
  graphicHeight: 404,


  /**
   * Sets up the view
   * @param {Number} level - The current level
   * @returns {undefined} undefined
   */
  init() {
    audioHelper.stopSound('theme');
    this.backgroundSquare = new PIXI.Graphics();
    this.backgroundSquare.beginFill(config.redColor);
    this.backgroundSquare.drawRect(
      0,
      0,
      window.innerWidth,
      window.innerHeight);
    renderHelper.stage.addChild(this.backgroundSquare);
    this.randomTextInt = Math.floor(Math.random() *
      ((data.gameOverData.text.length) - 0)) + 0;

    this.graphicsContainer = new PIXI.Container();
    renderHelper.stage.addChild(this.graphicsContainer);

    frameAnimationHelper.create(
      this.graphicsContainer,
      data.gameOverData.imagePaths,
      data.gameOverData.animationTime,
      data.gameOverData.loopAnimation,
      this.graphicWidth,
      this.graphicHeight,
      data.gameOverData.animationDelay);

    this.textContainer = new PIXI.Container();
    renderHelper.stage.addChild(this.textContainer);

    this.gameOverText = new PIXI.Text('',
      {
        font: '18px ' + config.fontName,
        fill: config.whiteColor,
        align: 'center',
      }
    );
    this.textContainer.addChild(this.gameOverText);
    this.gameOverText.resolution = 2;

    AppDispatcher.handleViewAction({
      actionType: AppConstants.RESET,
    });

    this.resizeListener = this.onResize.bind(this);
    window.addEventListener('resize', this.resizeListener);
    window.addEventListener('orientationchange', this.resizeListener);

    this.positionGraphics();

    this.writeTextInterval = setInterval(this.writeOutText.bind(this), 50);

    setTimeout(() => {
      router.navigate('leaderboard', true);
    }, 5000);
  },


  /**
   * Writes out the text
   * @returns {undefined} undefined
   */
  writeOutText() {
    const currentText = 'GAME OVER\n' +
      data.gameOverData.text[this.randomTextInt];
    this.textLetterInt++;
    const newText = currentText.slice(0, this.textLetterInt).toUpperCase();

    this.gameOverText.text = newText;

    if (this.textLetterInt === currentText.length) {
      clearInterval(this.writeTextInterval);
    }

    this.positionGraphics();
  },


  /**
   * Orientation change handler
   * @returns {undefined} undefined
   */
  onResize() {
    this.positionGraphics();
  },


  /**
   * Positions graphics
   * @returns {undefined} undefined
   */
  positionGraphics() {
    let graphicsY = Math.round(window.innerHeight - this.graphicHeight);
    if (graphicsY < 100) {
      graphicsY = 100;
    }

    this.graphicsContainer.x = Math.round((window.innerWidth / 2) - (this.graphicWidth / 2));
    this.graphicsContainer.y = graphicsY;

    this.gameOverText.x =
      Math.round((window.innerWidth / 2) - (this.gameOverText.width / 2));
    this.gameOverText.y = 20;
  },


  /**
   * Destroys the view
   * @returns {undefined} undefined
   */
  destroy() {
    window.removeEventListener('resize', this.resizeListener);
    window.removeEventListener('orientationchange', this.resizeListener);
    renderHelper.stage.removeChild(this.backgroundSquare);
    renderHelper.stage.removeChild(this.graphicsContainer);
    renderHelper.stage.removeChild(this.textContainer);
    frameAnimationHelper.destroyAllAnimations();
  },
};

export default gameOverView;



/** WEBPACK FOOTER **
 ** ./assets/js/src/views/game-over.js
 **/